<script>
import { LpTag } from '@thehotelsnetwork/lampo';

import i18n from '@/config/i18n';

export default {
  components: {
    LpTag,
  },
  props: {
    name: {
      type: String,
      default: 'Hotel',
    },
    url: {
      type: String,
      default: '',
    },
    onboarded: {
      type: Boolean,
      default: true,
    },
    ready: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    let statusTagColor;
    let statusTagText;

    const { t } = i18n.global;

    const statusTagConfig = {
      size: 'medium',
      radius: 'big',
      show: false,
    };

    // not ready? (countdown)
    if (!props.ready) {
      statusTagColor = 'primary';
      statusTagText = t('In Progress');
    }

    // not onboarded? (higher priority vs "ready" status)
    if (!props.onboarded) {
      statusTagColor = 'red';
      statusTagText = t('Pending');
    }

    if (statusTagColor && statusTagText) {
      statusTagConfig.show = true;
      statusTagConfig.color = statusTagColor;
      statusTagConfig.text = statusTagText;
    }

    return {
      statusTagConfig,
    };
  },
};
</script>

<template>
  <div class="flex items-center min-w-0 flex-grow">
    <div class="min-w-0 flex-grow">
      <div
        data-testid="property-status-name"
        class="font-normal truncate"
      >
        {{ name }}
      </div>
      <div
        v-if="url"
        data-testid="property-status-url"
        class="font-light text-sm text-base-700 truncate"
      >
        {{ url }}
      </div>
    </div>

    <LpTag
      v-if="statusTagConfig.show"
      :size="statusTagConfig.size"
      :radius="statusTagConfig.radius"
      :color="statusTagConfig.color"
      class="ml-2 whitespace-nowrap"
    >
      {{ statusTagConfig.text }}
    </LpTag>
  </div>
</template>
